import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import LineWithDot from "./img/Line wit Dot.svg";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import mentorshipIcon from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import mentorIcon from "./img/Icon_Mentor_White.svg";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import InputField from "../InputField";
import searchIcon from "./img/searchIcon.svg";
import { Country, State } from "country-state-city";
import arrow from "./img/arrow.png";
import "./styles.scss";
import Button from "../Button";
import Pagination from "react-js-pagination";
import GlobalDropDown2 from "../GlobalDropDown2";
import Select from "react-select";
import ChatBoxModal from "../../../../common/chatBoxModal";
import { Button as MaterialButton } from "@material-ui/core";
import {
  getNamesList,
  destructNamesList,
} from "../AdminMentorAction/dependencies/action";
import {
  getAdminMentorList,
  getPredefineOptionsList,
  getMentorlistCountersList,
  // getNamesList
} from "./dependencies/action";
import { PRODUCTION_MOVE_HIDDEN, PROFILE_KEY } from "../../../../common/constants/actionConstants";
import * as CryptoJS from "crypto-js";

export const ColumnNameAdmin = [
  {
    value: "sn",
    text: "NO.",
    sort: false,
  },
  {
    value: "mentorName",
    text: "MENTOR NAME",
    sort: true,
  },
  {
    ra3: "dpiitid",
    text: "MENTOR ID",
    sort: true,
  },
  {
    value: "applicationid",
    text: "APPLICATION ID",
    sort: true,
  },
  {
    value: "applicationdate",
    text: "APPLICATION DATE",
    sort: true,
  },
  {
    value: "applicationform",
    text: "APPLICATION FORM",
    sort: false,
  },
  {
    value: "applicationstatus",
    text: "APPLICATION STATUS",
    sort: false,
  },
  {
    value: "comments",
    text: "COMMENTS",
    sort: false,
  },
];

const customStyles = {
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),
};

const AllMentorList = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const html = document.getElementsByTagName("html")[0];
  //
  const headeradmintext = useRef(null);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [page, setPage] = useState(0);
  const [activeText, setActiveText] = useState(true);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [sortField, setSortField] = useState("fellowName");
  const [sortOder, setSortOrder] = useState("DESC");
  const [selectedRow, setSelectedRow] = useState("");
  const [activePage, setActivePage] = useState(1);
  const { getNamesList, getNamesListData, destructNamesList } = props;

  const defaultFormData = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };

  const defaultFormData2 = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      searchField: filterNameValue === "Select" ? "" : filterNameValue,
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      searchKey: null,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      status: selectedStatus,
    };
    getAdminMentorList(params);
    // let params = {
    //   sortKey: "name",
    //   sortOrder: "ASC",
    //   country: formData.country == "Select Country" ? formData.country : null,
    //   state: formData.state == "select" ? formData.state : null,
    //   industry: formData.industry == "select" ? "" : formData.industry, // optional
    //   function: formData.function == "select" ? "" : formData.function, // optional
    //   stage: formData.stage == "select" ? "" : formData.stage,
    //   searchField:
    //     formData?.name?.value == "select" ? null : formData?.name?.value,
    //   searchKey: null,
    //   pageFilter: {
    //     currentPage: pageNumber - 1,
    //     includeCount: true,
    //     pageSize: 10,
    //     sortField: "id",
    //     sortOrder: "ASC",
    //   },
    // };
    // getAdminMentorList(params);
  };
  const [formData, setFormData] = useState(defaultFormData);
  const newCountryArray = [];
  const newStateArray = [];
  const [appliedformData, setAppliedFormData] = useState(defaultFormData2);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const history = useHistory();
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    getAdminMentorList,
    mentorList,
    getPredefineOptionsList,
    getMentorlistCountersList,
    getCounter,
    getPredefineOptions,
    mentorListPaginate,
    getStepperTooltipData,
    getStepperData,
  } = props;
  useEffect(() => {
    html.style.overflow = "auto";

    getStepperTooltipData();
  }, []);
  useEffect(() => {
    //
    //
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    localStorage.setItem("allMentorList", "allMentorList");
    setTimeout(() => {
      // localStorage.removeItem("activitySummary");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allStartupList");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
      localStorage.removeItem("cohortApplication");
    }, 1000);
    let params = {
      listKey: "Mentor",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    let nameArrList = [];
    if (getNamesListData !== undefined && getNamesList !== null)
      getNamesListData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select Mentor",
          };
          setNameListValue((oldArray) => [...oldArray, arr2]);
        }
        let arr = {
          value: element.id,
          label: element.name,
        };
        if (getNamesListData.length >= nameListValue.length)
          setNameListValue((oldArray) => [...oldArray, arr]);
      });
  }, [getNamesListData]);
  useEffect(() => {
    const indDefaultObject = {
      value: "select",
      label: "Select Country",
    };

    const indDefaultObject2 = {
      value: "select",
      label: "Select State",
    };

    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });

    newCountryArray.unshift(indDefaultObject);
    State.getStatesOfCountry(newCountrySelect === true ? "IN" : null).map(
      (item) => {
        const newObject = {
          value: item.name,
          label: item.name,
        };

        newStateArray.push(newObject);
        setNewStateOptions(newStateArray);
      }
    );
    newStateArray.unshift(indDefaultObject2);
  }, [newCountrySelect]);
  useEffect(() => {
    getMentorList();
  }, [getAdminMentorList]);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: formData.country,
      state: formData.state,
      industry: formData.industry, // optional
      id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      // function: formData.function, // optional
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      stage: formData.stage, // optional
      status: selectedStatus,
    };
    getMentorlistCountersList(params);
  }, []);

  const sortCloumn = (name) => {
    if (sortField === name) {
      setSortField(name);
      setSortOrder(sortOder === "DESC" ? "ASC" : "DESC");
    } else {
      setSortField(name);
    }
  };
  const getMentorId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const getApplicationId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const ViewMentorApplicaiton = (applicationId, applicationStatus) => {
    setSelectedRow(applicationId);

    let reRoute = window.open(
      `/view-application/mentor-${applicationId}`,
      "_blank"
    );
    reRoute.id = applicationId;
    reRoute.applicationStatus = applicationStatus;
    reRoute.fromModule = "mentorList";
    // localStorage.setItem("allMentorList", "allMentorList");
    // window.location.reload();
    // reRoute();
    //   let timer = setInterval(function() {
    //     if(reRoute.closed) {
    //
    //            localStorage.setItem("mentorMenu", "mentorMenu");
    //            window.location.reload();
    //     }
    // }, 300);
    // history.push({
    //   pathname: "/view-application",
    //   state: {
    //     id: applicationId,
    //     applicationStatus: applicationStatus,
    //     fromModule: "mentorList",
    //   },
    // });
  };
  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
    //
    // history.push({
    //   pathname: `/mentor-profile/${item.email}`,
    //   state: { prevPage: "mentorPage",data:item },
    // });
  };
  const getMentorListName = (name) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      searchField: name === "Select" ? "" : name,
      status: selectedStatus,
      id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },

      status: selectedStatus,
    };
    getAdminMentorList(params);
  };
  const getMentorList = (status) => {
    setActivePage(1);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      searchField: filterNameValue === "Select" ? "" : filterNameValue,
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      status: status ? (status === "Total" ? "" : status) : selectedStatus,
    };
    getAdminMentorList(params);
  };
  const handleInputChange = (e, name) => {
    const { value } = e.target;

    setFormData((user) => {
      return { ...user, [name]: value };
    });

    const newFormData = {
      ...formData,
      [name]: value,
    };

    localStorage.setItem("formdata", JSON.stringify(newFormData));

    setAppliedFormData(newFormData);
  };

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  useEffect(() => {
    return () => {
      destructNamesList();
    };
  }, []);
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  return (
    <>
      <div
        className="mentorlistmaindiv mentorlist-moboleVIEW"
        style={{ marginTop: props.location.state?.pageLink ? "100px" : "0px" }}
      >
        <div className="dashboard-main2" style={{ background: "none" }}>
          <div className="topbackbtnparentdiv">
            <div
              className="dashboard-bottom-btn4 topbackbtnmentorlist"
              style={{ background: "transparent", border: "none" }}
            >
              <div className="newuserTooltip">
                <MaterialButton
                  className="topbackbtnactual top-btn"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    //
                    if (
                      props?.location?.state?.fromModule ===
                      "mentorDashboardHome"
                    ) {
                      localStorage.setItem(
                        "mentorDashboardHome",
                        "mentorDashboardHome"
                      );
                      localStorage.removeItem("allMentorList");
                      window.location.reload();
                      // activitySummary
                    } else if (
                      history?.location?.state?.fromModule === "activitySummary"
                    ) {
                      localStorage.setItem(
                        "activitySummary",
                        "activitySummary"
                      );
                      localStorage.removeItem("allMentorList");

                      window.location.reload();
                    } else if( history?.location?.state?.fromModule === "mentorMenu"){
                      localStorage.setItem("mentorMenu", "mentorMenu");
                      localStorage.removeItem("allMentorList");
                      window.location.reload();
                    }else{
                      localStorage.setItem("mentorRequests", "mentorRequests");
                      localStorage.removeItem("allMentorList");
                      window.location.reload();
                    }
                  }}
                  style={{
                    background: "#3ac2d7",
                  }}
                >
                  {" "}
                  Back
                </MaterialButton>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{
                    top: "69px",
                    width: "217px",
                    left: "71px",
                  }}
                >
                  {history?.location?.state?.fromModule === "activitySummary"
                    ? "Click to Go Activity Summary"
                    : props?.location?.state?.fromModule ===
                      "mentorDashboardHome"
                    ? "Click to Go My Dashboard"
                     : props?.location?.state?.fromModule ===
                    "mentorMenu"
                    ? "Click to Go Mentor Applications"
                  :"Click to Go Mentor Requests"}
                </span>
              </div>
            </div>
          </div>
          <div className="iconWith-heading allmenlistadminappwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                ADMIN DASHBOARD: ALL MENTORS LIST
              </h3>
            </div>
            {!PRODUCTION_MOVE_HIDDEN && <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>}
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew row mobileviewmentorbelow pading-01">
            <div
              className="mentorImageParent d-flex justify-content-end"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorIcon} className="sidebar-dashboard-icon2" />
            </div>
            <div className="dashboard-bottom-btn3 startup-button01">
              <p className="text-white">MENTORS</p>
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("");
                  getMentorList("Total");
                }}
                style={{ color: activeText ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                TOTAL MENTORS: {getCounter && getCounter.total}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "65px", width: "210px" }}
              >
                Click to View Total Mentors
              </span>
              {activeText ? <img src={LineWithDot} /> : ""}
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("ACTIVE");
                  getMentorList("ACTIVE");
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                ACTIVE MENTORS: {getCounter && getCounter.active}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "65px", width: "210px" }}
              >
                Click to View Active Mentors
              </span>
              {activeText2 ? <img src={LineWithDot} /> : ""}
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(false);
                  setSelectedStatus("INACTIVE");
                  getMentorList("INACTIVE");
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                INACTIVE MENTORS: {getCounter && getCounter.inactive}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "65px", width: "210px" }}
              >
                Click to View Inactive Mentors
              </span>
              {activeText3 ? <img src={LineWithDot} /> : ""}
            </div>
          </div>
          <div className="filter-row filter-row-common ">
            <div>
              <form className="container newfilterdivnow">
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-between mr-3 pl-2">
                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          getMentorListName(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Mentor"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Mentor
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />

                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="country"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="country"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.country}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              country: e.value == "select" ? null : e,
                            };
                          });

                          setFilterCountry(e.label);

                          if (e.label === "India") {
                            setNewCountrySelect(true);
                            setFilterState("");
                          } else {
                            setNewCountrySelect(false);
                            setFilterState("");
                            setFormData((user) => {
                              return {
                                ...user,
                                state: "",
                              };
                            });
                          }
                          setNewStateOptions("");
                        }}
                        options={newCountryOptions}
                        placeholder="Country"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Country
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div>
                  </div>
                  {/* <div
                    className="col-md-1 filter-text"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      color: "#838186",
                      fontWeight: 700,
                      height: "40px",
                    }}
                  >
                    Filter by
                  </div> */}
                  {/* <div
                    className="user-type-dropdown col-2 adminfilterdropdown3 filterdrop"
                    style={{ width: "13%" }}
                  >
                    <InputField
                      type="search"
                      name="search"
                      placeholder="Search"
                      value={formData.search}
                      onChange={handleInputChange}
                      containerClass={"form-group"}
                      className="subscribe-input-field"
                    />
                    <div className="btn-group">
                      <Button
                        icon={<img src={searchIcon} className="search-icon" />}
                        type="submit"
                        text=""
                        className="list-submit-button"
                      />
                    </div>
                  </div> */}

                  <div className="col-1 apply-section mentorGoBtnFix ">
                    <div className="newuserTooltip">
                      <Button
                        // onClick={handleClickOfFilter}
                        onClick={() => getMentorList(selectedStatus)}
                        text="GO"
                        className="filter-button top-btn newcoloredbtn"
                      ></Button>
                      <span
                        className="tooltiptext   tooltip-bottom"
                        style={{
                          left: "56px",
                          width: "126px",
                          height: "48px",
                          top: "42px",
                        }}
                      >
                        Click to Apply Filters
                      </span>
                    </div>
                    {/* <Button
                      icon={<img src={arrow} className="search-icon" />}
                      onClick={() => getMentorList(selectedStatus)}
                      text=""
                      className="green-btn filter-btn apply-admin-dashbtn newfilterBtnallmentor"
                    /> */}
                  </div>
                  {/* <div className="col-md-1 apply-section applymentorlistbtnmobile">
                    <Button
                      type="submit"
                      text="Apply"
                      className="green-btn filter-btn"
                      onClick={() => getMentorList(selectedStatus)}
                    />
                  </div> */}
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="searchBy"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="searchBy"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.name}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            name: e.name == "select" ? null : e,
                          };
                        });
                        setFilterName(e.name);
                        setFilterNameValue(e.value);
                        getMentorListName(e.value);
                      }}
                      options={nameListValue.length > 0 ? nameListValue : ""}
                      placeholder="Search Mentor"
                    />
                    {/* <div className="btn-group">
                      <Button
                        icon={<img src={searchIcon} className="search-icon" />}
                        type="submit"
                        text=""
                        className="list-submit-button"
                      />
                    </div> */}
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput countryinputadmndashmntrlist"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        // if (e.label === "India") {
                        //   setNewCountrySelect(true);
                        //   setFilterState("");
                        // } else {
                        //   setNewCountrySelect(false);
                        //   setFilterState("");
                        // }
                        // setNewStateOptions("");

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                          setFilterState("");
                        } else {
                          setNewCountrySelect(false);
                          setFilterState("");
                          setFormData((user) => {
                            return {
                              ...user,
                              state: "",
                            };
                          });
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div>

                  <div className="col-md-1 apply-section">
                    <Button
                      // type="submit"
                      text="GO"
                      className="green-btn filter-btn"
                      onClick={() => getMentorList(selectedStatus)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="totalTableCount ">
            Total Mentors Found: {mentorListPaginate?.totalElements} &lt;{" "}
            {mentorListPaginate?.currentPage} of {mentorListPaginate?.numPages}{" "}
            &gt;{" "}
          </div>
          {/* <h5>Total Member Found:   0/0 </h5> */}
          {mentorList && mentorList?.length > 0 ? (
            <div className="allMentor-table">
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="tableJustify fixColumbnWidth4">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          NO.
                        </div>
                      </th>
                      <th className="fixColumbnWidth" colspan="2">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          MENTOR
                        </div>
                      </th>
                      <th>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          MENTOR ID
                        </div>
                      </th>
                      <th>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          CITY
                        </div>
                      </th>
                      {/* <th>PROFILE</th> */}
                      {/* <th>APPLICATION</th> */}
                      <th>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          CONTACT
                        </div>
                      </th>
                      {/* <th>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          EMAIL
                        </div>
                      </th> */}
                      <th>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          MENTORSHIPS
                        </div>
                      </th>
                      {/* <th>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "45px",
                          }}
                        >
                          SEND MESSAGE
                        </div>
                      </th> */}
                      {/* <th>COMMENTS</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {mentorList &&
                      mentorList?.length > 0 &&
                      mentorList.map((item, index) => (
                        <tr
                          className={
                            item.id === selectedRow ? "purpleBackground" : ""
                          }
                          key={index}
                        >
                          {mentorListPaginate.currentPage === 1 ? (
                            <td>
                              {" "}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  // alignItems: "center",
                                  // height: "100px",
                                }}
                                className="serialnodivtable"
                              >
                                {index + 1}
                              </div>
                            </td>
                          ) : (
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                  // height: "100px",
                                }}
                              >
                                {index +
                                  1 +
                                  10 * (mentorListPaginate.currentPage - 1)}
                              </div>
                            </td>
                          )}
                          <td
                            className="menlistmennametd"
                            style={
                              {
                                // flexDirection: "row",
                                // display: "flex",
                                // justifyContent: "center",
                              }
                            }
                          >
                              {item.applicationStatus==="VERIFIED" &&
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={
                                  item.image === null ? hashImage : item.image
                                }
                                onClick={() =>
                                  ViewProfile(item?.email, item?.id)
                                }
                                // src={
                                //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                // }
                                className="sidebar-dashboard-icon2 newWidthIconFIx"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  // maxWidth: "none",
                                  // objectFit: "contain",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "46px",
                                  top: "88px",
                                  width: "150px",
                                }}
                              >
                                View Mentor Profile
                              </span>
                              <p className="shownametable">
                                {item.applicant_name}
                              </p>
                              <div
                                className="newuserTooltip shownametable"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "flex-start",
                                  // justifyContent: "center",
                                  height: "100px",
                                  width: "100%",
                                  // display: "flex",
                                }}
                                onClick={() =>
                                  ViewProfile(item?.email, item?.id)
                                }
                              >
                                <img
                                  src={profile}
                                  style={{
                                    width: "40px",
                                  }}
                                />
                                {/* <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-info-circle"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                </svg> */}
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "19px",
                                    top: "103px",
                                    width: "150px",
                                  }}
                                >
                                  View Mentor Profile
                                </span>
                                {/* <span className="tooltiptext-profile tooltip-bottomx">
                                View Mentor Profile
                              </span> */}
                              </div>
                            </div>
}
                          </td>
                          <td className="showmentornametd">
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                                height: "100px",
                                // maxWidth: "240px",
                              }}
                            >
                              <div
                                style={{
                                  alignItems: "center",
                                  display: "flex",
                                  maxWidth: "240px",
                                  minWidth: "240px",
                                }}
                              >
                                {item.applicant_name}
                              </div>
                              <div
                                className="d-flex justify-content-end newuserTooltip"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  height: "100px",
                                  width: "40px",
                                  display: "flex",
                                }}
                                onClick={() =>
                                  ViewProfile(item?.email, item?.id)
                                }
                              >
                                <img src={profile} />
                                {/* <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-info-circle"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                </svg> */}
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "19px",
                                    top: "103px",
                                    width: "150px",
                                  }}
                                >
                                  View Mentor Profile
                                </span>
                                {/* <span className="tooltiptext-profile tooltip-bottomx">
                                View Mentor Profile
                              </span> */}
                              </div>
                            </div>
                          </td>
                          {/* <td>M{getMentorId(item.id)}</td> */}
                          <td>
                            {/* {"M" + getMentorId(item.id)} */}
                            {item.applicationStatus === "VERIFIED" ? (
                              <div
                                className="menidmobile2 withfixheightdi"
                                style={{
                                  flexDirection: "row",
                                  // display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {"M" + getMentorId(item.id)}
                                </div>
                                <div
                                  className="d-flex justify-content-end newuserTooltip menidiconmobile decresingheigtt"
                                  style={{
                                    cursor: "pointer",
                                    // width: "fit-content",
                                    // alignItems: "end",
                                    // height: "5.9rem",
                                  }}
                                  onClick={() =>
                                    ViewMentorApplicaiton(
                                      item.id,
                                      item.applicationStatus
                                    )
                                  }
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                  </svg>
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      top: "102px",
                                      width: "150px",
                                      left: "9px",
                                    }}
                                  >
                                    View Application
                                  </span>
                                  {/* <span className="tooltiptext-profile tooltip-bottomx">
                                View Mentor Profile
                              </span> */}
                                </div>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td style={{verticalAlign:"middle"}}>
                            <div
                              className="menidmobile"
                              style={{
                                display: "flex",
                                width:"inherit",
                                height:"inherit",
                                display:"flex",
                                // justifyContent: "center",
                                // alignItems: "center",
                                // height: "100px",
                              }}
                            >
                              {item.city}
                            </div>
                          </td>
                          {/* <td>
                            <div className="newuserTooltip">
                              <a
                                onClick={() =>
                                  ViewProfile(item?.email, item?.id)
                                }
                                // href="#"
                                className="color-green"
                              >
                                View
                              </a>
                              <span className="tooltiptext tooltip-bottom">
                                View Profile
                              </span>
                            </div>
                          </td> */}
                          {/* <td>
                            <div className="newuserTooltip">
                              <a
                                onClick={() =>
                                  ViewMentorApplicaiton(
                                    item.id,
                                    item.applicationStatus
                                  )
                                }
                                className="color-green"
                              >
                                View
                              </a>
                              <span className="tooltiptext tooltip-bottom">
                                View Application
                              </span>
                            </div>
                          </td> */}
                          {item?.phone?.substr(0, 2) == "91" ? (
                            <td className="phoneNumberTable">
                              <div
                                style={{
                                  // display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                className="profilemenlistmobile"
                              >
                                <div
                                  style={{
                                    display: "flex",

                                    justifyContent: "left",
                                    alignItems: "center",
                                    wordBreak: "break-all",
                                    whiteSpace: "pre-wrap",
                                  }}
                                  className="profilemenlistmobiletext"
                                >
                                  +91 {item?.phone?.substr(2, item?.phone?.length)}
                                  <br />
                                  {item?.email}
                                </div>
                                { !PRODUCTION_MOVE_HIDDEN && 
                                <div
                                  className="d-flex justify-content-end newuserTooltip profilemenlistmobile2 semegess"
                                  style={{
                                    cursor: "pointer",
                                    // alignItems: "end",
                                    justifyContent: "center",
                                    // height: "100px",
                                    // width: "40px",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    src={buttonSendMessage}
                                    // src={
                                    //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                    // }
                                    // className="sidebar-dashboard-icon2"
                                    // style={{
                                    //   width: "100%",
                                    //   height: "100%",
                                    //   // maxWidth: "none",
                                    //   // objectFit: "contain",
                                    // }}
                                    onClick={() => {
                                      setChatBoxModalOpen(true);
                                      setMentorRequest(item);
                                      setMentorRequestId(item.id);
                                    }}
                                    className="profilemenlistmobile2img"
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      top: "105px",
                                      width: "120px",
                                      left: "20px",
                                    }}
                                  >
                                    Send Message
                                  </span>
                                </div>
}
                              </div>
                            </td>
                          ) : (
                            <td>
                              <div
                                style={{
                                  // display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                className="profilemenlistmobile"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "left",
                                    alignItems: "center",
                                  }}
                                  className="profilemenlistmobiletext"
                                >
                                  {item.phone}
                                  <br /> {item.email}
                                </div>
{ !PRODUCTION_MOVE_HIDDEN && 
                                <div
                                  className="d-flex justify-content-end newuserTooltip profilemenlistmobile2 semegess"
                                  style={{
                                    cursor: "pointer",
                                    // alignItems: "end",
                                    justifyContent: "center",
                                    // height: "100px",
                                    // width: "40px",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    src={buttonSendMessage}
                                    // src={
                                    //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                    // }
                                    // className="sidebar-dashboard-icon2"
                                    // style={{
                                    //   width: "100%",
                                    //   height: "100%",
                                    //   // maxWidth: "none",
                                    //   // objectFit: "contain",
                                    // }}
                                    onClick={() => {
                                      setChatBoxModalOpen(true);
                                      setMentorRequest(item);
                                      setMentorRequestId(item.id);
                                    }}
                                    className="profilemenlistmobile2img"
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      top: "105px",
                                      width: "120px",
                                      left: "20px",
                                    }}
                                  >
                                    Send Message
                                  </span>
                                </div>
}
                              </div>
                            </td>
                          )}
                          {/* <td>
                            {" "}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                                height: "100px",
                              }}
                            >
                              {item.email}
                            </div>
                          </td> */}
                          {/* <td>{item.comments}</td> */}
                          <td>
                            <div
                              style={{
                                // display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              className="applimenlistmobile"
                            >
                              {item.activeMentorships > 0 ? (
                                <>
                                <div className="w-100 h-100" style={{display:"contents"}}>
                                  <div className="applimenlistmobilemenitem">
                                    {" "}
                                    {item.activeMentorships}
                                  </div>

                                  <div
                                    className="d-flex justify-content-end newuserTooltip applimenlistmobilemenitemround"
                                    style={{
                                      cursor: "pointer",
                                      // alignItems: "end",
                                      justifyContent: "center",
                                      // height: "100px",
                                      width: "40px",
                                      minHeight:'6rem',
                                      display: "flex",
                                    }}

                                    // onClick={() => {
                                    //   if (item?.mentorshipId !== null) {
                                    //     // setIndexCounter(item.id);

                                    //     window.open(
                                    //       `/startup-dashboard/mentorships/engagement-summary/${item?.mentorshipId}`,
                                    //       "_blank"
                                    //     );
                                    //   } else {
                                    //     props.setSelectedMenu("mentorMentorships");
                                    //     history.push("/dashboard");
                                    //   }
                                    //
                                    //   // props.setSelectedMenu("mentorMentorships");
                                    // }}
                                  >
                                    <img
                                      src={mentorshipIcon}
                                      alt={item.title}
                                      onClick={() => {
                                        let reRoute = window.open(
                                          `/dashboard/mentorship-mentor/${item.id}`,
                                          "_blank"
                                        );
                                        // let reRoute = window;
                                        reRoute.startupData = item;
                                        reRoute.fromModule = "mentorList";
                                        // reRoute.my_special_setting = "Hello World";
                                      }}
                                    />
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={{
                                        top: "100px",
                                        width: "135px",
                                        marginLeft: "0px",
                                        left: "-53px",
                                      }}
                                    >
                                      View Mentorships
                                    </span>
                                  </div>
                                  </div>
                                </>
                              ) : (
                                <div style={{ paddingTop: "30px" }}>
                                  {item.activeMentorships}
                                </div>
                              )}
                            </div>
                          </td>
                          {/* <td
                            style={{
                              // flexDirection: "row",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "50px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                                cursor:"pointer"
                              }}
                            >
                              {
                                
                              }
                              <img
                                src={buttonSendMessage}
                                // src={
                                //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                // }
                                className="sidebar-dashboard-icon2"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  // maxWidth: "none",
                                  // objectFit: "contain",
                                }}
                                onClick={()=>{
                                  setChatBoxModalOpen(true);
                                  setMentorRequest(item);
                                  setMentorRequestId(item.id);
                                }}
                              />
                               <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{ top: "75px" }}
                                  >
                                   Send Message
                                  </span>
                            </div>
                          </td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {mentorList && mentorList.length > 0 ? (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={mentorListPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}

          <ChatBoxModal
            modalVisibility={chatBoxModalOpen}
            setModalVisibility={setChatBoxModalOpen}
            receiverInfo={mentorRequest}
            receiverId={mentorRequestId}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    mentorList: state.AdminMentorListReducer.getMentorList.data,
    mentorListPaginate: state.AdminMentorListReducer.getMentorList.paginate,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getCounter: state.AdminMentorListReducer.getMentorlistCountersList.data,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};

export default connect(mapStateToProps, {
  getAdminMentorList,
  // predefineOptions,
  getPredefineOptionsList,
  getMentorlistCountersList,
  getNamesList,
  getStepperTooltipData,
  destructNamesList,
})(withRouter(AllMentorList));
